import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause,ExplorableItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { SiteUserContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';
import { SiteUsers } from '~src/userManagement/services/resources/SiteUsers';
import { SiteUsersWithTokenResource } from '~src/userManagement/services/resources/SiteUsersWithToken';

import { getNoDefaultFilters } from '../../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const SiteUserDefinition: SpaceDefinition<'siteuser'> & ExplorableItemDefinition = {
  itemType: 'siteuser',
  contentType: 'siteuser',
  singularName: Messages.siteUser,
  pluralName: Messages.users,
  emptyStateMessage: Messages.usersEmptyMessage,
  contentFilterKeys: SiteUserContentType.filterKeys,
  filterClause: ServerFilterClauses.ContentType(['siteuser']) as ContentTypeFilterClause,
  defaultFilters: getNoDefaultFilters,
  supportedDisplayModes: ['list'],
  cardComponent: GenericCard,
  listViewIconUrl: null,
  contentSpaceUrl: (urls, id) => '', // note this is used for breadcrumbs/clicking on card and list view, //might have to be refactored to take in the entire item
  headerIconPath: (contentInfo: ISpaceItemDetailInfo<'siteuser'>) => {
    if (contentInfo.userImageUrl) {
      return contentInfo.userImageUrl;
    }
    return imgPath('user_content_type.svg');
  },
  getContentInfo: () => {
  },
  getBasicQuery: () => {
    const usersResource = SiteUsers.instance;
    return usersResource.all();
  },
  getResourceTokenQuery: () => {
    return SiteUsersWithTokenResource;
  }
};
